<script lang="ts" setup>
const { $switchRoute } = useI18n()
const { slug } = useRoute().params
const { data: post, error, pending: isFetching } = await useFetch(`/api/blog/post/${slug}`)

if (error.value) {
  throw createError({
    statusCode: 500,
    message: 'Nepodařilo se načíst článek',
    fatal: true,
  })
}

useHead({ title: post.value?.title ?? '' })

useSeoMeta({
  ogTitle: post.value?.title ?? '',
  ogDescription: stripHTML(post.value?.perex),
  ogImage: directusImg(post!.value!.featured_image!, 'og'),
  twitterTitle: post.value?.title ?? '',
  twitterDescription: stripHTML(post.value?.perex),
  twitterImage: directusImg(post!.value!.featured_image!, 'twitter'),
  // ogUrl:
})
</script>

<template>
  <div>
    <div v-if="!isFetching && post">
      <div v-auto-animate fubex-container mt-46px :data-test="getCypressId('blogDetail')" max-w-4xl mx-auto>
        <div flex gap-8px items-center justify-center>
          <FButton size="md" name="back" variant="outline" w-fit px-18px @click="$switchRoute('/blog')">
            <UnoIcon i-fubex-chevron-left-two h-14px w-14px text-center />
            <span paragraph-md>Zpět na blog</span>
          </FButton>
        </div>
        <div mt-22px items-center text-center>
          <NuxtLink v-for="tag in post.tags" :key="tag.bitbeli_tag_slug.slug" :to="`/blog/tag-${tag.bitbeli_tag_slug.slug}`" mx-4px>
            <BlogTag :tag="tag.bitbeli_tag_slug" :reverse="true" />
          </NuxtLink>
        </div>
        <div flex flex-col gap-16px items-start mt-26px>
          <h1 sm:display-lg heading2 text-neutral-900 font-700 text-center>
            {{ post.title }}
          </h1>
          <NuxtImg sizes="md:400px" :src="directusImg(post!.featured_image!, 'bitbeli-lg')" :alt="post.slug" w-full max-h-450px fubex-rounded-lg object-cover md:my-40px my-20px />
          <div w-full flex flex-col gap-10px>
            <h3 heading5 text-neutral-900 line-clamp-3>
              <span v-html="post.perex" />
            </h3>
            <div flex gap-8px items-center mt-10px>
              <div flex gap-8px items-center>
                <NuxtImg :src="directusImg(post!.author!.avatar!, 'bitbeli-sm') ?? 'https://placehold.co/85x85'" alt="" rounded-full w-30px h-30px />
                <h5 text-sm text-neutral-900>
                  {{ post.author.title }}
                </h5>
              </div>
              <h6 text-xs text-neutral-400>
                {{ formatDateTime(post.date_published, true) }}
              </h6>
            </div>
          </div>
        </div>
        <div mt-32px flex flex-col gap-32px>
          <div flex flex-col paragraph-md gap-1rem class="[&>h2]:heading4 [&>h3]:heading5 [&>ol]:list-decimal [&>ol]:pl-22px [&>*>a]:underline hover:[&>*>a]:bg-primary-100" v-html="post.text" />
        </div>
      </div>
      <div class="fubex-container">
        <div :data-test="getCypressId('newsletter')" mb-72px>
          <WidgetNewsletter />
        </div>
      </div>
    </div>
    <div v-else fubex-container>
      <USkeleton h-100px w="3/4" md:paragraph-md paragraph-sm font-500 flex flex-col mt-86px />
      <div mt-72px flex flex-col gap-32px>
        <div flex flex-col items-start md:flex-row gap-30px mb-72px>
          <div max-w="600px" w-full>
            <USkeleton h-50px max-w="80%" w-full md:paragraph-md paragraph-sm font-500 flex flex-col mt-16px />
            <USkeleton h-150px w-full md:paragraph-md paragraph-sm font-500 flex flex-col mt-16px />
            <USkeleton h-50px max-w="50%" w-full md:paragraph-md paragraph-sm font-500 flex flex-col mt-16px />
            <USkeleton h-250px w-full md:paragraph-md paragraph-sm font-500 flex flex-col mt-16px />
            <USkeleton h-50px w-full md:paragraph-md paragraph-sm font-500 flex flex-col mt-16px />
          </div>
          <USkeleton h-400px w-full md:paragraph-md paragraph-sm font-500 flex flex-col />
        </div>
      </div>
    </div>
  </div>
</template>
